import React from "react";
import { PayrollCalendarSettingsContainer } from "../../containers";

const PayrollCalendarSettings = (props) => {
  return <PayrollCalendarSettingsContainer {...props} />;
};

export default PayrollCalendarSettings;
